import React from 'react';
import Slide from 'react-reveal/Slide';
import SkillComponent from './SkillComponent';
import styles from './styles.module.scss';
import DownArrowIcon from '../../assets/down-arrow3.svg';

function SkillsBox() {
	return (
		<Slide bottom>
			<div className={`box`}>
				<h1 className='section-title'>Skills</h1>

				<div className={styles.gridContainer}>
					<SkillComponent skillName='Java' skillIconName='devicon-java-plain' />
					<SkillComponent
						skillName='Python'
						skillIconName='devicon-python-plain'
					/>
					<SkillComponent
						skillName='C++'
						skillIconName='devicon-cplusplus-plain'
					/>
					<SkillComponent
						skillName='Javascript'
						skillIconName='devicon-javascript-plain'
					/>
					<SkillComponent
						skillName='Html5'
						skillIconName='devicon-html5-plain'
					/>
					<SkillComponent skillName='Css3' skillIconName='devicon-css3-plain' />
					{/* <SkillComponent skillName="JQuery" skillIconName="devicon-jquery-plain" /> */}
					<SkillComponent
						skillName='Bootstrap'
						skillIconName='devicon-bootstrap-plain'
					/>
					<SkillComponent
						skillName='Sass'
						skillIconName='devicon-sass-original'
					/>
					<SkillComponent
						skillName='React'
						skillIconName='devicon-react-original'
					/>
					<SkillComponent
						skillName='Node js'
						skillIconName='devicon-nodejs-plain'
					/>
					<SkillComponent
						skillName='Express js'
						skillIconName='devicon-express-original'
					/>
					<SkillComponent
						skillName='MongoDB'
						skillIconName='devicon-mongodb-plain'
					/>
					<SkillComponent skillName='Git' skillIconName='devicon-git-plain' />
					<SkillComponent
						skillName='Github'
						skillIconName='devicon-github-plain'
					/>
					<SkillComponent
						skillName='Heroku'
						skillIconName='devicon-heroku-plain'
					/>
					<div className={styles.gridItem}>
						<i className={styles.skillIcon}>
							<span
								className={`iconify ${styles.picIcon}`}
								data-icon='logos-netlify'
								data-inline='false'
							></span>
						</i>
						<h4>Netlify</h4>
					</div>
				</div>

				<a href='#languagesBox' className='downArrow'>
					<img src={DownArrowIcon} alt='arrow'></img>
				</a>
			</div>

			<div className={`box moreBox ${styles.languagesBox}`} id='languagesBox'>
				<h1 className='section-title'>Languages</h1>
				<div className={styles.gridContainer}>
					<SkillComponent language={true} lang='Arabic' langDesc='(Native)' />
					<SkillComponent language={true} lang='English' langDesc='(Fluent)' />
					<SkillComponent
						language={true}
						lang='Deutsch'
						langDesc='(Survivable)'
					/>
					<SkillComponent language={true} lang='French' langDesc='(Beginner)' />
				</div>
			</div>
		</Slide>
	);
}

export default SkillsBox;
